import { getCityNameFailure, getPostalCodeFailure, getStreetNameFailure, requiredValidator } from 'validators';
const NO_FAILURES = {
    address1: null,
    address2: null,
    city: null,
    state: null,
    postalCode: null
};
function isEmptyAddress(value) {
    return Object.values(value).every((fieldValue)=>fieldValue.trim() === '');
}
export function getAddressFieldsFailures(value) {
    let { allowEmpty = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (allowEmpty && isEmptyAddress(value)) {
        return NO_FAILURES;
    }
    return {
        address1: requiredValidator(value.address1) ? getStreetNameFailure(value.address1) : 'required',
        address2: getStreetNameFailure(value.address2),
        city: requiredValidator(value.city) ? getCityNameFailure(value.city) : 'required',
        state: requiredValidator(value.state) ? null : 'required',
        postalCode: requiredValidator(value.postalCode) ? getPostalCodeFailure(value.postalCode) : 'required'
    };
}
export function isAddressFieldsValueValid(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return Object.values(getAddressFieldsFailures(value, options)).every((failure)=>failure == null);
}
export function getAddressFieldsErrors(failures, errorTexts) {
    return {
        address1: failures.address1 == null ? undefined : errorTexts.address1[failures.address1],
        address2: failures.address2 == null ? undefined : errorTexts.address2[failures.address2],
        city: failures.city == null ? undefined : errorTexts.city[failures.city],
        state: failures.state == null ? undefined : errorTexts.state[failures.state],
        postalCode: failures.postalCode == null ? undefined : errorTexts.postalCode[failures.postalCode]
    };
}
